<template>
  <v-menu
    ref="menuDate"
    v-model="menuDate"
    :close-on-content-click="false"
    :return-value.sync="value"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        icon="mdi-calendar"
        prepend-icon="mdi-calendar"
        @click:prepend="on.click"
        v-bind:value="value"
        v-on:input="$emit('input', $event)"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-date-picker
      v-bind:value="value"
      v-on:input="$emit('input', $event)"
      no-title
      scrollable
      :disabled="disabled"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menuDate = false">Закрыть</v-btn>
      <v-btn text color="primary" @click="$refs.menuDate.save(value)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "wapi-date-picker",
  props: {
    value: String,
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showOptions: true,
      menuDate: false
    };
  }
};
</script>